/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowdescriptionenglish3Inputs */

const en_aiflowdescriptionenglish3 = /** @type {(inputs: Aiflowdescriptionenglish3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de_aiflowdescriptionenglish3 = /** @type {(inputs: Aiflowdescriptionenglish3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englisch`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {Aiflowdescriptionenglish3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowdescriptionenglish3 = /** @type {((inputs?: Aiflowdescriptionenglish3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowdescriptionenglish3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowdescriptionenglish3(inputs)
	return de_aiflowdescriptionenglish3(inputs)
});
export { aiflowdescriptionenglish3 as "aiFlowDescriptionEnglish" }